import React, { PropsWithChildren } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import { makeStyles, Theme } from '@material-ui/core/styles';
import BackgroundThumbnail from '../BackgroundSelectionDialog/BackgroundThumbnail/BackgroundThumbnail';
import { getBackgroundConfig } from '../VideoProvider/useBackgroundSettings/useBackgroundSettings';
import { useAppSelector } from '../../redux/hooks';

const useStyles = makeStyles((theme: Theme) => ({
  drawer: {
    display: 'flex',
    width: theme.rightDrawerWidth,
    height: `calc(100% - ${theme.footerHeight}px)`,
  },
  thumbnailContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '5px',
    overflowY: 'auto',
  },
}));

interface BackgroundDialogProps {
  open: boolean;
  onClose(): void;
}

function BackgroundDialog({ open, onClose }: PropsWithChildren<BackgroundDialogProps>) {
  const collection: any = useAppSelector(state => state.collection.list);
  const classes = useStyles();
  const virtualBackgrounds = collection.tokenData?.decode?.virtualBackgrounds || [];
  const { imageNames, images } = getBackgroundConfig(virtualBackgrounds);

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="sm">
      <DialogTitle>Backgrounds</DialogTitle>
      <Divider />
      <DialogContent>
      <div className={classes.thumbnailContainer}>
        <BackgroundThumbnail thumbnail={'none'} name={'None'} />
        <BackgroundThumbnail thumbnail={'blur'} name={'Blur'} />
        {images.map((image, index) => (
          <BackgroundThumbnail
            thumbnail={'image'}
            name={imageNames[index]}
            index={index}
            imagePath={image}
            key={image}
          />
        ))}
      </div>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default BackgroundDialog;
